export default __webpack_public_path__ + "static/funnels-group-aggregation-light-mode-f653f0f087012048d3b17f2a9f6223db.png";